import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
    },
  },
});

// Action creators
export const { login, logout } = userSlice.actions;

// Selector
export const selectUser = (state) => state.user.user;

// Reducer
export default userSlice.reducer;
